import React from "react";
import * as S from "./styles";

export const Slide3: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Text>
          <p>
            Luísa Sonza, por sua vez, lançou, em 2020, um dos clipes mais
            comentados do ano, “Modo turbo”, que tem no feat. a própria Pabllo e
            a Anitta. A produção, aliás, é estimada como a mais cara já
            realizada no Brasil, custando cerca de 1,5 milhão de reais. A música
            faz parte de Doce22 (2021), o álbum mais pessoal da cantora até
            então e um dos maiores sucessos musicais deste ano. Se você não
            chorou ouvindo “Penhasco” ou rebolou ao som de “VIP *-*”,
            definitivamente não viveu até agora 2021 direito. Os hits, é claro,
            estão entre os mais ouvidos do pop no Amazon Music, desbancando
            grandes nomes internacionais.
          </p>

          <p>
            Com forte influência do soul e do R&B, o último EP de Gloria Groove,
            Affair (2020), traz exatamente o que a gente ama no pop: um vozeirão
            de arrepiar, letras românticas e batidas sensuais para dançar sem
            vergonha. A drag queen, conhecida pelos clipes com narrativas
            originais e identidades visuais marcantes, entregou produções
            lindíssimas para o novo single “A tua voz”, que, por sinal, tem um
            dos vídeos mais emocionantes dos últimos tempos. Além de suas
            colaborações com gigantes da música nacional de todos os gêneros,
            Gloria imprime cada vez mais a sua história e suas origens em seu
            trabalho, marcando seu lugar como uma das principais figuras do pop
            brasileiro.
          </p>
          <p>
            Nas imagens a seguir, as três divas se multiplicam como as
            tendências que ditam e as pessoas que inspiram. Suas imagens se
            repetem tanto quanto seus hits em nossas playlists (e em nossa
            cabeça). Elas revelam todos os seus lados para se mostrarem únicas –
            mesmo em movimentos tão plurais como a música pop e a cultura
            brasileira.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
